import NoDataIcon from "@assets/svg/no-data.svg";
import { Button, Spinner } from "@components/index";
import gate from "@gate/index";
import { commafy, getTextAndColorByNumber } from "@lib/index";
import { useRouter } from "next/router";
import React, { FC } from "react";
import { useQuery } from "react-query";

import {
  convertMiladiToJalali,
  convertNumberToPriceFormat,
} from "../../../../src/utils";
import ChartArrowIcon from "./../../../../assets/svg/student/wallet/chart-arrow.svg";
import DepositIcon from "./../../../../assets/svg/student/wallet/deposit.svg";
import WithdrawIcon from "./../../../../assets/svg/student/wallet/withdraw.svg";
import WithdrawalRequestIcon from "./../../../../assets/svg/student/wallet/withdrawal-request.svg";

type Props = {
  availableBalance: number;
};

const WalletToman: FC<Props> = ({ availableBalance }) => {
  const router = useRouter();
  const { data: dataTransaction, isLoading: isLoadingTransaction } = useQuery(
    `wallet-transaction-toman`,
    () =>
      gate.getTransactionsEachUserWithCoin({
        search: "",
        pageSize: 30,
        pageNumber: 1,
        sortBy: "Date",
        isSortAsc: false,
        fieldSearchs: [
          {
            fieldName: "",
            type: "",
            text: "",
            min: 0,
            max: 0,
            opration: "",
            options: [],
          },
        ],
        coin: "TOMAN",
      }),
    {
      select: ({ data }: any) => data,
    }
  );
  const getValueByKey = (item: any, type: string) => {
    return item.items.find((values: any) => values.fieldName === type);
  };
  return (
    <>
      <div className="relative mx-[10px] mb-[20px] flex flex-col flex-wrap items-center md:mt-0 md:flex-row">
        <div className="w-full flex-[0.7] md:w-auto">
          <h2 className="pl-[8.5rem] text-xs font-bold text-[#4A4A4A] md:pl-0 md:pl-0 md:text-sm lg:text-lg">
            لیست تراکنش‌های کیف پول تومانی شما
          </h2>
        </div>
        <div className="relative w-full flex-1 md:w-auto">
          {/*<div className="flex items-center">*/}
          {/*  */}
          {/*</div>*/}
          <div className="mt-4 ml-0 text-xs font-bold text-[#4A4A4A] md:mt-0 md:text-left md:text-sm lg:ml-3 lg:text-lg">
            <ChartArrowIcon className="inline-block w-[20px] text-[#4E4E56] md:w-auto" />{" "}
            موجودی کیف پول تومانی:{" "}
            <span className="font-bold text-[#183BA7]">
              {convertNumberToPriceFormat(availableBalance)}
            </span>{" "}
            تومان
          </div>
        </div>
        <div className="w-full text-left lg:w-auto">
          {/*<div className="flex-0 text-left">*/}
          <Button
            // isLoading={isLoading}
            onClick={() => router.push("/student/withdraw-money")}
            className="absolute top-0 left-0 m-0 w-max-content rounded border-2 border-[#1D3FA8] bg-[#1D3FA8] py-[4px] px-[5px] text-xs text-white transition-all hover:ring-2 md:relative md:mt-2 lg:mt-0 lg:py-[8px] lg:px-[9px] lg:text-sm"
          >
            <WithdrawalRequestIcon className="ml-1 inline-block" />
            درخواست برداشت
          </Button>
          {/*</div>*/}
        </div>
      </div>
      <table className="responsive-table">
        <thead>
          <tr>
            <td scope="col" className="w-[80px]" />
            <th scope="col">شماره ارجاع</th>
            <th scope="col">شرح تراکنش</th>
            <th scope="col">
              مبلغ <span className="font-medium">(تومان)</span>
            </th>
            <th scope="col">تاریخ</th>
            <th scope="col" className="w-[120px]">
              نوع تراکنش
            </th>
          </tr>
        </thead>
        <tbody>
          {!isLoadingTransaction ? (
            dataTransaction?.rows.length ? (
              dataTransaction.rows.map((item: any) => {
                return (
                  <tr>
                    <td className="!hidden !pr-4 md:!inline-block">
                      {getValueByKey(item, "IsIncrease")?.value === "برداشت" ? (
                        <WithdrawIcon />
                      ) : (
                        <DepositIcon />
                      )}
                    </td>
                    <td data-label="شماره ارجاع:" className="relative">
                      <span
                        className={`absolute left-0 top-[6px] inline-block h-min rounded-full bg-[#DAF4EB] px-7 py-1 text-[#34C38F] md:hidden ${
                          getTextAndColorByNumber(
                            getValueByKey(item, "TransactionType")?.typeEnum
                          )?.class
                        }`}
                      >
                        {
                          getTextAndColorByNumber(
                            getValueByKey(item, "TransactionType")?.typeEnum
                          )?.text
                        }
                      </span>
                      {item?.id}
                    </td>
                    <td data-label="شرح تراکنش:">
                      {getValueByKey(item, "PayDescription").value}
                    </td>
                    <td data-label="مبلغ(تومان):">
                      {commafy(getValueByKey(item, "NormalizePrice").value)}
                    </td>
                    <td data-label="تاریخ:">
                      {convertMiladiToJalali(
                        getValueByKey(item, "Date")?.value
                      )}
                    </td>
                    <td
                      data-label="نوع تراکنش:"
                      className="!hidden md:!table-cell"
                    >
                      <span
                        className={`h-min rounded-full px-7 py-1 ${
                          getTextAndColorByNumber(
                            getValueByKey(item, "IsIncrease")?.value
                          )?.class
                        }`}
                      >
                        {
                          getTextAndColorByNumber(
                            getValueByKey(item, "IsIncrease")?.value
                          )?.text
                        }
                      </span>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={6} className="!text-center">
                  <NoDataIcon className="-mt-5 inline-block h-[200px] w-full md:h-[40vh]" />
                  <p className="-mt-5 text-base text-[#4E4E56] md:-mt-8">
                    شما هنوز تراکنشی ثبت نکرده اید!
                  </p>
                </td>
              </tr>
            )
          ) : (
            <tr>
              <td colSpan={6}>
                <div className="py-20 text-center">
                  <Spinner className="mx-auto h-10 w-10 animate-opacity animate-fade-in-down" />
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  );
};

export default WalletToman;
